export default __webpack_public_path__ + "static/media/gallery_02.9e2c2ad4.jpg";